import type { PropertyWithId } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { propertyNumberSchema } from './propertyNumberSchema'
import { propertySelectSchema } from './propertySelectSchema'
import { z } from 'zod'

export const propertyWithIdSchema = z.union([z.lazy(() => propertySelectSchema), z.lazy(() => propertyNumberSchema)]) as unknown as ToZod<PropertyWithId>

export type PropertyWithIdSchema = PropertyWithId